onDomReady(function() {
   if ($('notifications')) {
      Notifications.initialize();
   }
});

/**
 * This is the fun little JS that deals with making sure notifications show up
 * to the user, and lets the user close them all ajaxy like.
 *
 * NOTE: The FAQ notification must be done here because of the way we cache the page.
 */
export var Notifications = (window.Notifications = {
   container: null,

   initialize: function() {
      this.container = $('notifications');

      var notifications = $$('#notifications .notification');

      // We're all done if we have no notifications to display.
      if (notifications.length === 0) {
         return false;
      }

      var msgIds = notifications.map(function(el) {
         return el.get('id');
      });

      this.container.setStyles({
         position: Browser.ie ? 'absolute' : 'fixed',
         top: '0px',
         left: '0px',
      });

      // Offset the body content to make room for the notifications.
      var height = this.getContainerHeight();
      var oldBGY = this.getBGY();
      var newBGY = oldBGY + height;

      $(document.body).setStyle('padding-top', height);
      this.setBGY(newBGY);

      this.container.show();

      // Send delete command to php for all messages.
      this.container.addEvent(
         'click',
         function(ev) {
            ev.stop();
            new Request.AjaxIO('ajaxRemoveNotification').send(msgIds);

            TweenMax.to(document.body, 0.3, { 'padding-top': 0 });

            this.setBGY(oldBGY);

            // Hide notifications if deleted.
            $$('.notification').each(function(el) {
               if (el !== null) {
                  el.nix(true);
               }
            });

            if (this.container != null) {
               if (Browser.ie) {
                  this.container.dispose();
               } else {
                  this.container.nix(true);
               }
            }
         }.bind(this)
      );

      this.container.getChildren('div').each(function(el) {
         el.getChildren('a').each(function(elm) {
            elm.addEvent('click', function(event) {
               // this will prevent the event from bubbling up
               event.stopPropagation();
            });
         });
      });
   },

   getContainerHeight: function() {
      var height;
      this.container.makeInvisible().show();
      height = this.container.getSize().y;
      this.container.hide().makeVisible();
      return height;
   },

   getBGY: function() {
      var body = $(document.body);
      var style =
         body.getStyle('background-position-y') || body.getStyle('background-position') || '';
      var match = style.match(/(-?\d+)px$/);
      return match ? parseInt(match[1], 10) : 0;
   },

   setBGY: function(y) {
      var body = $(document.body);
      if (body.getStyle('background-position-y')) {
         body.setStyle('background-position-y', y + 'px');
      } else {
         var current = body.getStyle('background-position');
         var x = current.split(/ +/)[0];
         body.setStyle('background-position', x + ' ' + y + 'px');
      }
   },

   /**
    * Static function to get the height of the notifications. I found myself
    * doing this a lot, so I thought I'd better make it a function.
    */
   getHeight: function() {
      var notificationHeight = 0;

      if ($('notifications')) {
         notificationHeight = $('notifications').getHeight();
      }

      return notificationHeight;
   },
});
